import axios from "axios";
export default {
    getTaskStatistics: (params) => axios.post("/Tasks/GetStatistics", { ...(params || {}) })
};
